<div class="black_div"></div>


<div class="content_wrapper py-4">
  <div class="content">
    <div class="flex flex-col gap-2 mb-5">
      <h1 class="text-hurrey-20 md:text-hurrey-24 lg:text-hurrey-28 bold_font">Disclaimer</h1>
      <p class="text-hurrey-12 md:text-hurrey-20 lg:text-hurrey-24">The information provided on this Site is for general information
        purposes only. By using this Site you acknowledge and agree to the terms of this Disclaimer.</p>
    </div>

    <h2 class="text-hurrey-12 md:text-hurrey-20 lg:text-hurrey-24 bold_font mt-4">General Information</h2>
    <p class="text-hurrey-12 md:text-hurrey-20 lg:text-hurrey-24 my-2">The information provided by <strong class="bold_font">Apeiros Eduventures Pvt. Ltd</strong> ("we," "us," or "our") on
      <strong class="bold_font">https://www.theatomo.com/</strong> (the "Site") is for general informational purposes only. All
      information on the Site is provided in good faith, however we make no representation or warranty of any kind,
      express or implied, regarding the accuracy, adequacy, validity, reliability, availability, or completeness of any
      information on the Site.</p>

    <p class="text-hurrey-12 md:text-hurrey-20 lg:text-hurrey-24 my-2 bold_font">UNDER NO CIRCUMSTANCE SHALL WE HAVE ANY LIABILITY TO
      YOU FOR ANY LOSS OR DAMAGE OF ANY KIND INCURRED AS A RESULT OF THE USE OF THE SITE OR RELIANCE ON ANY INFORMATION
      PROVIDED ON THE SITE. YOUR USE OF THE SITE AND YOUR RELIANCE ON ANY INFORMATION ON THE SITE IS SOLELY AT YOUR OWN RISK.</p>

    <h2 class="text-hurrey-12 md:text-hurrey-20 lg:text-hurrey-24 bold_font mt-4">External Links Disclaimer</h2>
    <p class="text-hurrey-12 md:text-hurrey-20 lg:text-hurrey-24 my-2">The Site may contain links to other websites or content belonging to or
      originating from third parties. Such external links are not investigated, monitored, or checked for accuracy by us.
      WE DO NOT WARRANT, ENDORSE, GUARANTEE, OR ASSUME RESPONSIBILITY FOR THE ACCURACY OR RELIABILITY OF ANY INFORMATION
      OFFERED BY THIRD-PARTY WEBSITES LINKED THROUGH THE SITE.</p>

    <h2 class="text-hurrey-12 md:text-hurrey-20 lg:text-hurrey-24 bold_font mt-4">Professional Disclaimer</h2>
    <p class="text-hurrey-12 md:text-hurrey-20 lg:text-hurrey-24 my-2">The Site cannot and does not contain professional advice (e.g., medical, legal, financial).
      The content is provided for general informational and educational purposes only and is not a substitute for professional
      advice. BEFORE TAKING ANY ACTION BASED UPON SUCH INFORMATION, WE ENCOURAGE YOU TO CONSULT WITH THE APPROPRIATE PROFESSIONALS.</p>

    <h2 class="text-hurrey-12 md:text-hurrey-20 lg:text-hurrey-24 bold_font mt-4">Affiliates / Sponsored Content</h2>
    <p class="text-hurrey-12 md:text-hurrey-20 lg:text-hurrey-24 my-2">We may include links to third-party products and services and may
      receive an affiliate commission for purchases made via those links. This helps support maintenance of the Site.</p>

    <h2 class="text-hurrey-12 md:text-hurrey-20 lg:text-hurrey-24 bold_font mt-4">Errors and Omissions</h2>
    <p class="text-hurrey-12 md:text-hurrey-20 lg:text-hurrey-24 my-2">While we have made every attempt to ensure that the information
      contained on this Site has been obtained from reliable sources, <strong class="bold_font">The Atomo</strong> is not
      responsible for any errors or omissions, or for the results obtained from the use of this information. All information is
      provided "as is," with no guarantee of completeness, accuracy, timeliness, or the results obtained from using it.</p>

    <h2 class="text-hurrey-12 md:text-hurrey-20 lg:text-hurrey-24 bold_font mt-4">Fair Use</h2>
    <p class="text-hurrey-12 md:text-hurrey-20 lg:text-hurrey-24 my-2">This Site may contain copyrighted material the use of which has not
      always been specifically authorized by the copyright owner. We make such material available in our efforts to advance
      public understanding of relevant topics and believe this constitutes a "fair use" of copyrighted material. If you wish to
      use copyrighted material from this Site for purposes beyond fair use, you must obtain permission from the copyright owner.</p>

    <h2 class="text-hurrey-12 md:text-hurrey-20 lg:text-hurrey-24 bold_font mt-4">Contact Us</h2>
    <p class="text-hurrey-12 md:text-hurrey-20 lg:text-hurrey-24 my-2">If you have any feedback, comments, requests for technical support,
      or other inquiries, please contact us by email:</p>

    <div class="flex flex-col gap-2">
      <a class="text-hurrey-12 md:text-hurrey-20 lg:text-hurrey-24" href="mailto:info@theatomo.com"><strong class="bold_font">Email:</strong>
        info&#64;theatomo.com</a>
    </div>

  </div>
</div>
